<template>
  <div class="row no-print" style="max-width: 1024px; margin: 0 auto;">
    <ButtonBack></ButtonBack>
  </div>
  <div class=" diploma flex flex-column align-items-center">
    <input type="file" id="photo" style="display:none"/>

    <div class="titleRow">
      <img class="titleBg" src="~@/assets/image/platform/frame-level.svg">
      <div class="title">
        <p style="margin-top: 10px">DIPLOMA</p>
        <p class="level">level {{ buddyData.level }}</p>
      </div>
    </div>

    <div class="pictureRow">

      <!--
      <div class="bg">
        <img class="borderTop" src="~@/assets/image/platform/background/activity_border.svg" alt="">
        <img class="bgTop" src="~@/assets/image/bb_background.svg">
        <img class="bgFloor" src="~@/assets/image/bb_floor.svg">
        <img class="borderBot" src="~@/assets/image/platform/background/activity_border.svg" alt="">
      </div>
      -->

      <div class="pictureFrame flex-row ">

        <div class="photoFrame">

          <!--
          <v-button class="upload-button mt-3 mr-3 no-print" button-text="Foto uploaden" :enabled="true"
                    @click="uploadClicked"></v-button>
                    -->

          <button class="upload-button-2 mt-3 mr-3 no-print"
                  @click="uploadClicked">Foto uploaden
          </button>
          <!--
          <div class="frame">
            <img class="frameTop" src="~@/assets/image/platform/frame/frame_medium_top.svg" alt="">
            <img class="frameMid" src="~@/assets/image/platform/frame/frame_medium_mid.svg" alt="">
            <img class="frameBot" src="~@/assets/image/platform/frame/frame_medium_bot.svg" alt="">
          </div>
          -->
          <div class="classPhotoContainer classPhoto" style="width: 100%; height: 85%">
            <img class="classPhoto" :src="photo" alt="">
          </div>

          <div class="frame">
            <img class="frameTop" src="~@/assets/image/platform/frame/frame_medium_top.png" alt="">
            <img class="frameMid" src="~@/assets/image/platform/frame/frame_medium_mid.svg" alt=""
                 style="visibility: hidden">
            <img class="frameBot" src="~@/assets/image/platform/frame/frame_medium_bot.png" alt="">
          </div>

        </div>

        <div class="buddyContainer">
          <DiplomaBuddy v-if="buddyData.id !== null" :buddy="buddyData"></DiplomaBuddy>
          <!--<DiplomaBuddy2 :buddy="buddyData"></DiplomaBuddy2>-->

        </div>

      </div>
    </div>

    <div class="bodyAndSignature">
      <div class="bodyRow">
        <div class="bg">
        </div>

        <!--<img class="borderTop" src="~@/assets/image/platform/background/activity_border.svg" alt="">-->
        <p class="headerText" style="margin-bottom: 0">Goed gedaan, {{ buddyData.buddyConfig.className }}!</p>
        <p class="headerText" style="font-weight: normal; font-size: 1.2rem; margin-top: -8px;">
          Dankzij jullie ben ik fitter, voel ik me beter in mijn vel en heb ik jullie als nieuwe vrienden.
        </p>
      </div>

      <div class="signatureRow">
        <div class="poot">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2994.97 2587.13">
            <path class="bb_colour-01"
                  d="m572.53,1247.16c32.35-49.98,65.98-80.41,134.42-142.34,34.21-30.96,65.81-59.55,108.4-87.12,81.97-53.05,149.88-67.01,203.12-77.35,108.06-20.99,88.63-26.6,204.01-52.29,73.99-16.47,108.21,2.32,160.42.46,54.56-1.94,84.5,11.7,163.26,42.12,181.22,69.99,162.6,51.93,229.85,85.11,52.08,25.69,116.43,57.96,188.77,119.59,80.68,68.73,142.19,121.13,170.94,227.44,7.85,29.02,3.03,24.38,18.14,187.53,18.35,198.26,23.7,184.15,24.99,245.49,2.07,98.33,4.36,207.6-52.41,340.15-42.36,98.9-98.59,165.83-136.06,209.77-55.63,65.24-128.67,150.88-232.37,186.6-53.9,18.57-93.56,15.86-156.54,11.56-33.9-2.31-142.33,44.39-229.74,3.48-89.46-41.87-93.4-35.32-177.57-63.61-53.95-18.13-57.07-7.09-118.1-26.81-72.41-23.39-73.14-40.74-155.59-76.81-90.77-39.71-102.1-61.5-164.72-101.88-39.58-25.52-37.99-34.25-82.52-63.83-71.17-47.28-68.76-96.24-107.42-120.24-105.27-65.36-148.55-271.8-125.54-436.57,5.63-40.3,16.36-78.76,38.12-156.77,35.12-125.9,53.08-190.29,94.11-253.68Z"/>
            <path class="bb_colour-01"
                  d="m26.28,823.07c-3.56,63.67,26.43,111.61,69.54,180.51,27.4,43.81,51.9,69.44,63.3,80.75,26.48,26.27,54.46,53.45,100.18,68.49,18.21,5.99,58.19,18.57,105.47,5.33,39.41-11.04,63.53-34.31,78.91-49.14,34.41-33.2,49.53-68.57,61.67-97.8,11.94-28.73,23.18-55.8,24.59-90.46,1.85-45.62,12.74-68.61-17.45-144.67-44.85-112.97-55.96-118.32-83.1-144.65-63.55-61.66-170.41-38.53-194.51-33.31-81.46,17.64-129.93,69.15-144.85,86.2-17.17,19.63-59.82,68.39-63.75,138.77Z"/>
            <path class="bb_colour-01"
                  d="m1188.73,672.1c-86.46-49.81-96.47-175.46-97.79-202.52-.86-17.69,3.16-46.49,11.2-104.09,8.63-61.76,15.04-106.17,33.26-161.94,17.76-54.35,36.21-87.28,53.15-111.74,19.82-28.61,95.55-56.2,150.75-59.25,41.01-2.27,40.93-7.96,68.9-9.07,75.42-2.99,134.63,36.67,147.36,45.6,40.84,28.63,60.7,61.43,84.04,99.97,17.92,29.59,45.22,75.69,55.19,141.65,7.54,49.93,1.54,87.3-6.58,137.92-6.34,39.46-12.64,76.72-35.52,120.11-14.9,28.26-31.44,48.9-42.33,61.19-18.69,21.09-36.95,41.71-65.06,55.44-14.95,7.31-30.19,11.45-131.82,12.86-45,.63-67.5.94-81.02.16-71.82-4.17-109.05-6.33-143.74-26.31Z"/>
            <path class="bb_colour-01"
                  d="m1882.66,730.45c-3.49-26.04-6.98-52.06,2.35-83.53,8.22-27.72,18.85-34.29,58.05-88.03,49.36-67.68,41.05-64.95,71.14-99.08,42.88-48.62,81.32-74.45,89.44-79.81,21.6-14.28,43.05-28.45,74.92-38.63,58.8-18.77,109.39-9.99,133.66-5.49,27.97,5.19,71.37,13.25,113.58,46.14,42.05,32.77,60.6,72.79,80.1,114.89,11.16,24.09,23.33,50.81,28.75,88.47,4.76,33.12,1.5,57.57-5.04,106.48-8.09,60.51-12.13,90.76-30.63,126-14.33,27.29-18.48,22-45.69,64.27-37.33,58.01-31.31,70.78-55.08,96.98-36.25,39.95-86.05,49.72-108.5,54.12-14.81,2.9-75.44,13.26-139.19-16.04-35.34-16.24-31.61-26.27-88.76-67.08-75.93-54.22-88.99-41.14-121.35-76.58-45.22-49.52-53.63-112.23-57.77-143.08Z"/>
            <path class="bb_colour-01"
                  d="m2365.89,1304.34c31.12-56,76.85-83.91,100.83-98.14,39.98-23.73,73.89-31.38,117.14-41.14,54.14-12.22,95.44-21.54,149.87-14.17,15.16,2.05,91.07,13.49,157.98,70.91,17.08,14.65,33.99,29.47,46.83,55.01,18.73,37.26,29.58,80.5,29.95,122.25,1,114-5.3,145.72-27,184-56.59,99.83-183.25,155.42-199.69,161.28-74.93,26.69-138.02,16.4-166.94,11.31-39.09-6.88-112.51-19.8-164.39-80.4-32.47-37.93-43.27-79.08-59.58-141.25-8.68-33.08-16.26-62.91-15.34-103.85.64-28.1,2.26-75.29,30.33-125.8Z"/>
          </svg>

        </div>
        <div class="signature"><p>{{ buddyData.name }}</p></div>
      </div>
    </div>


    <div class="logoBar">
      <div class="left">

      </div>
      <div class="right">
        <p class="hashtag">#WieSportDieWint</p>
        <img src="~@/assets/image/logos/logo-MOEV.png" alt="">
        <img src="~@/assets/image/logos/Sport-vlaanderen.png" alt="">

      </div>
    </div>

    <div class="footer">
      <div class="footer-wrapper">
        <p>&copy; Beweegbuddy, Sport Vlaanderen, MOEV</p>
      </div>
    </div>


  </div>

  <div class="buttonBar no-print">
    <v-button class="print-button mt-3 no-print" button-text="Diploma afdrukken" :enabled="true"
              @click="printPage"></v-button>
  </div>



</template>

<script>

import VButton from "@/components/UI/VButton.vue";
import { BuddyApi } from "sandpiper_api";
import { MirrorParts } from "@/mixins/MirrorParts.js";
import AccessoryLibrary from "@/mixins/AccessoryLibrary.js";
import { AID } from "@/enums/AccessoryIdEnum.js";
import DiplomaBuddy from "@/components/Diploma/DiplomaBuddy.vue";
import ButtonBack from "@/components/UI/ButtonBack.vue";

export default {
  name: "Diploma",
  components: { VButton, DiplomaBuddy, ButtonBack },
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      photo: null,
      buddyId: null,
      buddyFetched: false,
      buddyData: {
        name: null,
        id: null,
        fitness: {
          posture: 0,
          colorVibrancy: 0,
          animation: 0,
        },
        avatar: null,
        buddyConfig: {
          className: '',
          school: {
            id: null,
            name: '',
            postalCode: '',
          },
          schoolYear: {
            endDate: null,
            startDate: null,
          },
          studentCount: null,
        },
        expNextLevel: null,
        experience: null,
        level: null,
        bodyPartIds: {
          head: { name: 'head', id: "" },
          head_fuzz: { name: 'head_fuzz', id: "" },
          head_wrinkles: { name: 'head_wrinkles', id: "" },
          body_wrinkles: { name: 'body_wrinkles', id: "" },
          eyes: { name: 'eyes-01', id: "" },
          antenna: { name: 'antenna-01', id: "" },
          snout: { name: 'snout', id: "" },
          whiskers: { name: 'whiskers-05', id: "" },
          nose: { name: 'nose-01', id: "" },
          mouth: { name: 'mouth-01', id: "" },
          middle: { name: 'body', id: "" },
          ear_left: { name: 'ears-01', id: "" },
          ear_right: { name: 'ears-01', id: "" },
          arm_left: { name: 'arm', id: "" },
          arm_right: { name: 'arm', id: "" },
          leg_left: { name: 'leg', id: "" },
          leg_right: { name: 'leg', id: "" },
          eyebrow_left: { name: 'eyebrow', id: "" },
          eyebrow_right: { name: 'eyebrow', id: "" },
          tail: {name: 'tail', id: ""},

        },
        accessoryIds: {
          hat: { name: '', id: "" },
          shirt: { name: '', id: "" },
          sleeve_left: { name: '', id: "" },
          sleeve_right: { name: '', id: "" },
          shoe_left: { name: '', id: "" },
          shoe_right: { name: '', id: "" },
          hand: { name: '', id: "" },
          pants: { name: '', id: "" },
        },
        colors: {
          buddy_primary: '',
          buddy_secondary: '',
          buddy_tertiary: '',
          accessory_primary: '',
          accessory_secondary: '',
          accessory_tertiary: '',
        }
      },
    }
  },
  methods: {
    uploadClicked()
    {
      document.querySelector("#photo").click();
    },
    handleUpload()
    {
      this.photo = URL.createObjectURL(document.getElementById("photo").files[0]);
    },
    printPage()
    {
      //this.hideFooter();
      window.print();
      // setTimeout(this.showFooter, 500);

    },

    async fetchBuddy()
    {
      if (this.fetchingBuddy) return;

      try
      {
        this.fetchingBuddy = true;

        console.log("fetching buddy with id " + this.buddyId)
        let buddyInfo = await this.doApiRequest(() => new BuddyApi().getBuddy(this.buddyId));
        this.applyBuddyData(buddyInfo);
      }
      catch (e)
      {
        console.log(e);

        await this.$router.push({
          name: "agenda"
        });
      }
      finally
      {
        this.fetchingBuddy = false;
      }
    },

    applyBuddyData(data)
    {
      let bodyPartIds = {
        'antennas': 'antenna',
        'eyes': 'eyes',
        'mouth': 'mouth',
        'nose': 'nose',
        'ears': 'ear_left',
        'markings': 'whiskers',
      }

      let accessoryIds = {
        accessory: "hand",
        head: "hat",
        legs: "pants",
        chest: "shirt",
        feet: "shoe_left",
      }

      for (const [ key, value ] of Object.entries(data))
      {
        if (value !== undefined)
        {
          if (key === 'body')
          {
            for (const [ key, value ] of Object.entries(data.body))
            {
              if (value !== undefined)
              {
                this.buddyData.bodyPartIds[bodyPartIds[key]] = value;

              }
            }
          }
          else if (key === 'outfit')
          {
            for (const [ key, value ] of Object.entries(data.outfit))
            {
              if (value !== undefined)
              {
                this.buddyData.accessoryIds[accessoryIds[key]] = value;

              }
            }
          }
          else
          {
            if (this.buddyData[key] !== undefined)
            {
              this.buddyData[key] = value;
            }
          }
        }
      }

      if (data.body.skinColor !== undefined)
      {
        this.buddyData.colors.buddy_primary = data.body.skinColor.primary;
        this.buddyData.colors.buddy_secondary = data.body.skinColor.secondary;
        this.buddyData.colors.buddy_tertiary = data.body.skinColor.tertiary;
      }


      if (data.outfit.colors !== undefined)
      {
        this.buddyData.colors.accessory_primary = data.outfit.colors.primary !== "" ? data.outfit.colors.primary : "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = data.outfit.colors.secondary !== "" ? data.outfit.colors.secondary : "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = data.outfit.colors.tertiary !== "" ? data.outfit.colors.tertiary : "rgb(243,238,238)";
      }
      else
      {
        this.buddyData.colors.accessory_primary = "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = "rgb(243,238,238)";
      }

    },

    applyPawColors()
    {
      document.querySelectorAll('.bb_colour-01').forEach(el =>
      {
        el.style.fill = this.buddyData.colors['buddy_primary'];
      });

      document.querySelectorAll('.bb_colour-02').forEach(el =>
      {
        el.style.fill = this.buddyData.colors['buddy_secondary'];
      });

      document.querySelectorAll('.bb_colour-03').forEach(el =>
      {
        el.style.fill = this.buddyData.colors['buddy_tertiary'];
      });

      document.querySelectorAll('.outline').forEach(el =>
      {
        el.style.fill = '#140f0a';
      });
    }
  },
  watch: {
    buddyData: {
      handler()
      {
        if (this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '')
        {
          //this.showLoadIcon = false;

          //mirror all body parts and accessories that need to be mirrored
          for (const part in MirrorParts)
          {
            if (part in this.buddyData.bodyPartIds)
            {
              if (this.buddyData.bodyPartIds[MirrorParts[part]] !== this.buddyData.bodyPartIds[part])
              {
                this.buddyData.bodyPartIds[MirrorParts[part]] = this.buddyData.bodyPartIds[part];
              }
            }

            if (part in this.buddyData.accessoryIds)
            {
              if (this.buddyData.accessoryIds[MirrorParts[part]] !== this.buddyData.accessoryIds[part])
              {
                this.buddyData.accessoryIds[MirrorParts[part]] = this.buddyData.accessoryIds[part];
              }
            }
          }

          let sleeve = AccessoryLibrary.getSleeveForShirtId(this.buddyData.accessoryIds[AID.SHIRT].name);
          if (sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== sleeve.id)
          {
            this.buddyData.accessoryIds['sleeve_left'] = sleeve;
            this.buddyData.accessoryIds['sleeve_right'] = sleeve;
          }
          else if (!sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== '')
          {
            this.buddyData.accessoryIds['sleeve_left'] = { name: '', id: '' };
            this.buddyData.accessoryIds['sleeve_right'] = { name: '', id: '' };
          }

        }
      },
      deep: true,
    },
  },
  async mounted()
  {
    const inputElement = document.getElementById("photo");
    inputElement.addEventListener("change", this.handleUpload, false);

    if (this.$route.params.id)
    {
      this.buddyId = this.$route.params.id;
    }
    else
    {
      this.buddyId = 2;
    }

    //document.body.style.backgroundColor = "white";


    await this.fetchBuddy();
    this.buddyFetched = true;

    this.applyPawColors();

    //const footer = document.getElementsByClassName("footer")[0];
    //footer.classList.add("invisible");


  }
}
</script>

<style lang="scss" scoped>

.btn-back {
  color: $font-dark;
  text-decoration: none;
  font-weight: bold;

  i {
    color: $primary-blue;
    margin-right: 0.5rem;
  }

  &:hover {
    text-decoration: underline;
  }
}

.diploma {
  display: flex;

  //width: 100%;
  width: 29.7cm !important;
  height: 21cm !important;

  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  position: relative;
}

.titleRow {
  width: 75%;
  //margin-top: 100px;
  //top: 140px;
  height: 120px;
  z-index: 3;

  display: flex;
  justify-content: center;
  position: absolute;

  .titleBg {
    width: 70%;
    height: 100%;
    position: absolute;
  }

  .title {
    width: 900px;
    //height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    flex-direction: column;

    p {
      font-size: min(4vw, 5vh);
      font-weight: bold;
      color: white;
      margin-bottom: 0;
      margin-top: 0;
      height: 42%;
      z-index: 2;

      &.level {
        font-size: min(2vw, 3vh);
        height: 30%;
      }
    }
  }
}

.pictureRow {
  width: 100%;
  height: 500px;
  margin-top: 130px;
  //overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 70px;

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;

    img {
      object-fit: cover;
    }

    .borderTop {
      position: absolute;
      width: 100%;
    }

    .borderBot {
      position: absolute;
      left: 0;
      bottom: 0;
      transform: rotate(180deg);
      width: 100%;
    }

    .bgTop {
      width: 100%;
      height: 80%;
    }

    .bgFloor {
      width: 100%;
      height: 20%;
    }
  }
}

.pictureFrame {
  width: 100%;
  height: 100%;
  display: flex;
  //margin-top: 10px;
  position: relative;
  //padding-left: 20px;

  .photoFrame {
    width: 750px;
    height: 100%;
    position: relative;

    .classPhoto {
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: lightcyan;

      object-fit: cover;
      //mask-image: image(url(~@/assets/image/platform/frame-level.svg));
      -webkit-clip-path: polygon(0% 13%, 1% 11%, 6% 2%, 81% 2%, 95% 5%, 100% 13%, 100% 95%, 93% 100%, 6% 100%, 0% 95%);
      clip-path: polygon(0% 13%, 1% 11%, 6% 2%, 81% 2%, 95% 5%, 100% 13%, 100% 95%, 93% 100%, 6% 100%, 0% 95%);
    }

  }

  .buddyContainer {
    width: 242px;
    height: 70%;
    position: absolute;
    left: 754px;
    top: 21px;
  }
  
}

.frame {
  width: 100%;
  height: 88%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: absolute;

  .frameTop {
    aspect-ratio: 11.5476;
  }

  .frameMid {
    flex-grow: 1;
    object-fit: cover;
  }
}

.upload-button {
  width: 300px;
  position: absolute;
  z-index: 2;
  left: 150px;
  bottom: 62px;
}

.upload-button-2 {
  //background-color: $primary-blue;
  background-image: url(~@/assets/image/platform/button/bb_button.svg);
  background-color: transparent;
  color: $font-light;
  //box-shadow: $default-shadow;
  border: none;

  width: 292px;
  height: 50px;

  font-size: 1.25rem;

  position: absolute;
  z-index: 2;
  left: 230px;
  bottom: 123px;

}

.buttonBar {
  display: flex;
  justify-content: center;
  margin-bottom: 60px;

  .print-button {
    width: 300px;
  }
}

.bodyAndSignature {
  width: 90%;
  height: 77px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -60px;
}


.bodyRow {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  //left: -160px;
  width: 76%;
  margin-top: 10px;

  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
  }

  img {
    width: 100%;
    position: relative;
    top: -1px;
  }
}

.headerText {
  max-width: 950px;
  font-size: 1.7rem;
  font-weight: bold;
  color: #016FB7;
  margin: 0 auto;
  text-align: center;
  //margin-bottom: 3rem;
  //margin-top: 3rem;

}

.signatureRow {
  /*  position: absolute;
    top: 682px;
    right: 168px;
    width: 200px;*/
  width: 24%;
  height: 85%;
  display: flex;
  position: relative;
  top: 10px;
  left: 10px;
}

.poot {
  //width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  //position: absolute;
  //top: 58px;
  //left: -88px;

  svg {
    height: 100%;
    aspect-ratio: 1;
  }
}

.signature {
  width: 100%;
  height: 100%;
  display: flex;
  transform: rotate(-5deg);
  //justify-content: center;
  align-items: center;
  //transform: rotate(354deg);

  p {
    font-size: 1.7rem;
    font-family: "InkFree", sans-serif;
    margin-bottom: 0;
    margin-left: 10px;
  }

  span {
    margin-left: 10px;
    display: inline-block;

    img {
      height: 30px;
      aspect-ratio: 1/1;
    }
  }
}

.footer {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  //margin-top: 100px;
  position: absolute;
  bottom: 53px;
  padding: 5px;


  .footer-wrapper {
    height: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    font-style: italic;
    color: $primary-blue;
    margin-bottom: 0;

  }
}

.hashtag {
  //color: rgb(255, 80, 43);
  color: white;
  background-color: #016FB7;;
  padding: 0px 5px 0px 5px;
  margin: 0;
  font-weight: bold;
  font-size: 1.3rem;
}

.logoBar {
  width: 100%;
  height: 55px;
  display: flex;
  justify-content: flex-end;
  margin-top: 45px;
  //align-items: stretch;

  .left, .right {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    //align-items: stretch;


    p, img {
      margin-left: 15px;
      margin-right: 15px;
      object-fit: contain;
    }

    img {
      height: 100%;
    }
  }
}

@media print {

  body {
    //background-color: white !important;
  }
  .no-print {
    display: none;
    height: 0;
  }

  @page {
    size: A4 landscape;
    // margin: 0;
    margin: 10mm 10mm 10mm 10mm;
  }

  body {
    width: 29.7cm !important;
    height: 21cm !important;
    //margin: 30mm 45mm 30mm 45mm;
    /* change the margins as you want them to be. */
  }

}
</style>